import isOutOfViewport from 'Util/is-out-of-viewport';

export default class SiteNav {
  constructor(el) {
    this.el = el;
    this.dropdowns = this.el.querySelectorAll('.js-nav-dropdown');

    this.dropdowns.forEach((dropdown) => {
      const parent = dropdown.parentElement;
      parent.classList.add('has-dropdown');

      const link = dropdown.previousElementSibling;
      this.checkPosition(dropdown);

      link.addEventListener('mouseenter', () => {
        this.checkPosition(dropdown);
      });
    });
  }

  checkPosition(dropdown) {
    const isOut = isOutOfViewport(dropdown);

    if (isOut.right) {
      dropdown.classList.add('is-edge');
    }
  }
}
